import { Controller } from "stimulus";
import "foundation-sites";
import $ from "jquery";

export default class extends Controller {
  static targets = ["role", "searchInput", "backResetButton", "title", "rolesList", "roleItem", "submenuTitle"];

  connect() {
    // Only initialize if this element has the roles marketplace functionality
    if (!this.hasRoleTarget) {
      return;
    }
    this.selectedRoles = [];
    this.category = {};
    this.lastRemoved = null;
    this.anotherCategoryDiv = null;
    this.industryHasCategories = this.element.dataset.industryHasCategories === 'true';
    this.roleBox = document.querySelector(".dotted-box-roles");
    this.roleTextComponent = document.querySelector(".job-text-selection-roles");
    this.roleIcon = document.querySelector(".add-job-roles");
    this.roleTextElement = document.getElementById("selected-roles-types");
    this.applyButton = this.element.querySelector(".roles-apply-button");
    $(this.roleTarget).foundation();
    document.addEventListener("click", this.handleOutsideClick.bind(this));
    document.addEventListener("keydown", this.handleEscapePress.bind(this));
    this.submenuTitleTargets.forEach((submenuTitle) => {
    submenuTitle.addEventListener('click', this.preventBackEvent.bind(this));
    });
    if (this.industryHasCategories) {
      this.updatedCategories();
    } else {
      this.updatedMainCategories();
    }
    this.updatedNewRoles();
    this.showSelectedRoles();
    this.updateSelectedText();
    this.disableEnterKey();
  }

  handleBackReset() {
    const isInSubmenu = this.isInSubmenu();
    this.resetSearchInputs(this.searchInputTarget.closest('.search-input-wrapper'));
    this.showNoResultsMessage(true);

    if (isInSubmenu) {
      this.updateApplyButtonVisibility();
    } else {
      this.resetOptions();
    }
  }

  handleSearch(event) {
    if (!this.industryHasCategories) {
      this.filterRoles(event);
      return;
    }

    const isInSubmenu = this.isInSubmenu();

    if (isInSubmenu) {
      this.filterRoles(event);
    } else {
      this.filterRolesForHealthCare(event );
    }
  }

  isInSubmenu() {
    const activeSubmenu = this.rolesListTarget.querySelector('.is-drilldown-submenu.is-active');
    return activeSubmenu !== null;
  }

  changeHeader(buttonText, searchPlaceholderText, titleText) {
    this.backResetButtonTarget.textContent = buttonText;
    this.searchInputTarget.placeholder = searchPlaceholderText;
    this.titleTarget.textContent = titleText;
  }

  updatePickARoleText(hide = true, text = 'Pick a role') {
    const pickARole = document.getElementById('pick-a-role');
    if (hide) {
      pickARole.style.display = 'none';
      return;
    }

    pickARole.style.display = 'block';
    const pickRoleTitle = pickARole.querySelector('div');

    pickRoleTitle.textContent = text;
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
    document.removeEventListener("keydown", this.handleEscapePress.bind(this));
  }

  preventBackEvent(event) {
    event.stopPropagation();
  }

  updatedNewRoles() {
    const selectedRolesUpdated = JSON.parse(localStorage.getItem('selectedRolesUpdated'));
    if (!selectedRolesUpdated) return;

    selectedRolesUpdated.forEach((subRole) => {
      this.selectedRoles.push(subRole);
      this.updateSelectedText();
    });
  }

  updatedCategories() {
    const queryParams = new URLSearchParams(window.location.search);
    const subCategoryFromParams = queryParams.getAll('roles[]');

    if (subCategoryFromParams.length === 0) {
      localStorage.removeItem('updateCatergoryHash');
      localStorage.removeItem('selectedRolesUpdated');
      return;
    }

    // Build category mapping from DOM instead of localStorage
    const categoryUpdated = {};
    subCategoryFromParams.forEach((subCategory) => {
      // Split ID and name if in "ID,Name" format
      const [roleId, roleName] = subCategory.includes(',') ? subCategory.split(',') : [null, subCategory];
      const searchValue = roleName || subCategory;

      // Find the role in the DOM to get its category
      const roleElement = this.element.querySelector(`[data-role-type="${searchValue}"]`);

      if (roleElement) {
        const categoryElement = roleElement.closest('.roles-main')?.querySelector('.roles-main-position');
        if (categoryElement) {
          const mainCategory = categoryElement.textContent.trim();
          categoryUpdated[subCategory] = mainCategory; // Store with original format
        }
      }
    });

    if (Object.keys(categoryUpdated).length > 0) {
      this.category = categoryUpdated;
      this.updateCategory();

      subCategoryFromParams.forEach((subCategory) => {
        const mainCategory = categoryUpdated[subCategory];
        if (mainCategory) {
          const [roleId, roleName] = subCategory.includes(',') ? subCategory.split(',') : [null, subCategory];
          this.addRoleToDisplay(roleName || subCategory, roleId, mainCategory);
        }
      });
    } else {
      this.category = {};
    }
  }

  updatedMainCategories() {
    const queryParams = new URLSearchParams(window.location.search);
    const subCategoryFromParams = queryParams.getAll('roles[]');

    if (subCategoryFromParams.length === 0) {
      localStorage.removeItem('updateCatergoryHash');
      localStorage.removeItem('selectedRolesUpdated');
      return;
    }

    const categoryUpdated = {};
    subCategoryFromParams.forEach((subCategory) => {
      // Split ID and name if in "ID,Name" format
      const [roleId, roleName] = subCategory.includes(',') ? subCategory.split(',') : [null, subCategory];
      const searchValue = roleName || subCategory;
      categoryUpdated[subCategory] = searchValue; // For main roles, category is the role itself
    });

    if (Object.keys(categoryUpdated).length > 0) {
      this.category = categoryUpdated;

      subCategoryFromParams.forEach((subCategory) => {
        const [roleId, roleName] = subCategory.includes(',') ? subCategory.split(',') : [null, subCategory];
        const searchValue = roleName || subCategory;
        this.addMainRoleToDisplay(searchValue, roleId);
      });
    } else {
      this.category = {};
    }
  }

  filterRoles(event) {
    const search = document.getElementById('search-input');
    const searchInput = search.querySelector(".role-search-input");
    const searchTerm = searchInput.value.toLowerCase();
    const roleSubs = document.querySelectorAll(".roles-sub-text");

    let hasResults = false;

    roleSubs.forEach((roleSub) => {
      const roleText = roleSub.textContent.toLowerCase();

      if (roleSub.classList.contains("selected")) {
        roleSub.style.display = "none";
      } else {
        if (roleText.includes(searchTerm.trim())) {
          roleSub.style.display = "";
          roleSub.parentElement.style.display = "";
          hasResults = true;
        } else {
          roleSub.style.display = "none";
          roleSub.parentElement.style.display = "none";
        }
      }
    });

    this.showNoResultsMessage(hasResults);
  }

  disableEnterKey() {
    document.addEventListener("keydown", (e) => {
      if (e.target.matches(".role-search-input") && e.keyCode === 13) {
        e.preventDefault();
      }
    });
  }

  toggleRole(event) {
    const roleType = event.currentTarget.dataset.roleType;
    if (event.currentTarget.parentElement.classList.contains('role-disabled')) return;

    const roleId = event.currentTarget.dataset.roleId;
    const mainCategory = event.currentTarget.dataset.categoryName;
    const roleValue = roleId ? `${roleId},${roleType}` : roleType;
    const selectedIndex = this.selectedRoles.indexOf(roleValue);
    const row = event.currentTarget.closest(".roles-main");
    const roleItem = event.currentTarget.parentElement;

    if (selectedIndex > -1) {
      // Remove role
      roleItem.classList.remove("role-selected");
      this.selectedRoles.splice(selectedIndex, 1);
      localStorage.removeItem('selectedRolesUpdated');
      this.removeRoleFromDisplay(roleType);
    } else if (this.selectedRoles.length < 3) {
      // Add role
      roleItem.classList.add("role-selected");
      this.selectedRoles.push(roleValue);
      this.addCategoryData(roleValue, mainCategory);
      if (row) this.resetSearchInputs(row);
      this.addRoleToDisplay(roleType, roleId, mainCategory);
    }

    this.updateSelectedRoles();

    $('.js-marketplace-category-back').click();
    if (this.isInSubmenu()) {
      this.resetSearchInputs(this.searchInputTarget.closest('.search-input-wrapper'));
    }

    this.updateApplyButtonVisibility();
    this.updateLimitMessage();
    $(this.roleTarget).foundation("open");
  }

  updateSelectedRoles() {
    const roles = Array.from(document.querySelectorAll('#search-categories-with-roles li:not([data-role-identifier])'));
    const selectedRoleNames = this.selectedRoles.map(role => role.split(',')[1]);
    const isAtLimit = this.selectedRoles.length >= 3;

    roles.forEach(role => {
      const isSelected = selectedRoleNames.includes(role.dataset.id);

      role.classList.toggle('role-selected', isSelected);
      role.classList.toggle('role-disabled', !isSelected && isAtLimit);
    });
  }

  updateLimitMessage(){
    const selectedRolesContainer = this.element.querySelector(".add-another");
    const existingAddAnother = selectedRolesContainer.querySelector(".another-category");
    if (existingAddAnother) existingAddAnother.remove();

    if (this.selectedRoles.length !== 3) return;

    this.anotherCategoryDiv = document.createElement("div");
    this.anotherCategoryDiv.classList.add("another-category");

    this.anotherCategoryDiv.innerHTML =
    this.selectedRoles.length === 3 ? "Max of 3 roles selected" : this.selectedRoles.length > 0 ? "Add another" : "";
    selectedRolesContainer.appendChild(this.anotherCategoryDiv);
  }

  updateSelectedText(isClear = false) {
    const selectedRoleCount = isClear ? 0 : this.selectedRoles.length;

    if (selectedRoleCount === 0) {
      this.roleTextElement.innerHTML = "Any";
      this.roleTextComponent.style.marginLeft = "0.438rem";
      this.roleBox.style.justifyContent = "center";
      document.querySelector("button.dotted-box-roles span img").style.display = "inline";
      this.roleTextComponent.style.width = "auto";

    } else {
      this.lastRemoved = true;
      const selectedRolesToShow = this.selectedRoles.slice(0, 3);
      const roleText = selectedRolesToShow.map(role => {
        // Extract only the role name (after comma) for display
        const [roleId, roleName] = role.includes(',') ? role.split(',') : [null, role];
        const displayName = roleName || role;
        return `<span class="selected-role">${displayName}</span>`;
      }).join(" ");

      this.roleTextElement.classList.remove("opacity");
      this.roleIcon.classList.remove("opacity");
      this.roleTextComponent.style.width = "100%";
      this.roleBox.style.justifyContent = "flex-start";
      this.roleBox.style.padding = "0.2rem 0.23rem";
      this.roleTextComponent.style.display = "flex";
      this.roleTextComponent.style.marginLeft = "0";
      this.roleTextComponent.style.gap = "0.2rem";
      document.querySelector("button.dotted-box-roles span img").style.display = "none";
      this.roleTextElement.innerHTML = roleText;
    }
  }

  addRoleToDisplay (roleType, roleId, mainCategory = '') {
    const container = document.createElement('div')
    container.dataset.category = mainCategory
    container.dataset.roleType = roleType
    container.classList.add('main-category-container')
    container.innerHTML = `
        <div style="display: flex; align-items: center" data-role-type="${roleType}">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <input id="checkbox-${roleType}"
                    class="role-checkbox"
                    type="checkbox"
                    checked
                    data-role-type="${roleType}"
                    data-role-id="${roleId}"
                    data-action="change->roles-marketplace#toggleCheckbox" style="margin: 0;" />
                <div style="display: flex; flex-direction: column;">
                    ${mainCategory && `<p class="category-title" style="margin: 0; padding: 0;">${mainCategory}</p>`}
                    <span class="role-checkbox-text" onclick="event.preventDefault();">${roleType}</span>
                </div>
            </div>
        </div>
    `

    this.element.querySelector('.selected-roles-container').appendChild(container)
    this.updateLimitMessage()
  }

  removeRoleFromDisplay(roleType) {
    this.removeCategoryData(roleType);

    const subcategoryItem = document.querySelector(`.selected-roles-container [data-role-type="${roleType}"]`);
    if (subcategoryItem) subcategoryItem.remove();

    // Check if this was the last role and clean up the message
    if (this.selectedRoles.length === 0 && this.anotherCategoryDiv) {
      this.anotherCategoryDiv.innerHTML = '';
    }
  }

  toggleCheckbox(event) {
    const roleCategory = event.currentTarget.dataset.roleType;
    const roleId = event.currentTarget.dataset.roleId;
    const role = document.querySelector(`[data-id="${roleCategory}"]`);
    const roleValue = roleId ? `${roleId},${roleCategory}` : roleCategory;

    if (event.currentTarget.checked) {
      this.selectedRoles.push(roleValue);
    } else {
      this.selectedRoles = this.selectedRoles.filter((role) => role !== roleValue);
      role.classList.remove("role-selected");
      this.removeRoleFromDisplay(roleCategory);
    }

    this.updateSelectedRoles();
    this.updateLimitMessage()
    this.updateApplyButtonVisibility();
  }

  updateApplyButtonVisibility() {
    document.getElementById('role-search-and-selection').classList.toggle('hidden', this.selectedRoles.length === 0);
    this.changeHeader("Clear", "Search for roles within categories", "Select up to 3 roles:");
    this.updatePickARoleText();

    const applyButton = this.element.querySelector('.roles-apply-button');
    applyButton.style.display = this.selectedRoles.length > 0 ? 'inline-block' : 'none';
      this.roleTarget.focus();
      this.roleTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });

    $(this.rolesListTarget).foundation('_hideAll');
  }

  openDropdown() {
    this.selectedRole = document.querySelectorAll(".selected-role");
    const industry_name = window.location.hostname.split('.')[0]
    this.roleBox.classList.add("selected");

    $(this.roleTarget).foundation("open");
    const applyButton = this.element.querySelector('.roles-apply-button');
    const selectedUpdatedRole = JSON.parse(localStorage.getItem('selectedRolesUpdated'));
    if (!selectedUpdatedRole) {
      this.roleTextElement.classList.add("opacity");
      this.roleIcon.classList.add("opacity");
    }
    if (this.selectedRoles.length > 0) {
      this.selectedRole.forEach(function(role) {
        role.classList.add("opacity");
      });
      applyButton.style.display = 'inline-block';
    } else {
      applyButton.style.display = 'none';
    }

    if (industry_name != 'healthcare'){
      this.resetMainSearchInputs();
    }
    $(this.roleTarget).foundation("open");
  }

  closeDropdown() {
    this.selectedRole = document.querySelectorAll(".selected-role");
    this.roleBox.classList.remove("selected");

    if (this.selectedRoles.length > 0) {
      this.selectedRole.forEach(function(role) {
        role.classList.remove("opacity");
      });
    }
    this.roleTextElement.classList.remove("opacity");
    this.roleIcon.classList.remove("opacity");
    $(this.roleTarget).foundation("close");
  }

  handleOutsideClick(event) {
    const dropdown = this.roleTarget;
    if (!dropdown.contains(event.target) && !this.element.contains(event.target)) {
      this.closeDropdown();
    }
  }

  applySelection() {
    localStorage.setItem('selectedRolesUpdated', JSON.stringify(this.selectedRoles));

    // Clear page when roles change
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('page');

    if (Array.isArray(this.selectedRoles)) {
      const selectedRoles = [...new Set(this.selectedRoles)];
      currentUrl.searchParams.delete('roles[]');
      selectedRoles.forEach(role => {
        currentUrl.searchParams.append('roles[]', role);
      });
      window.location.href = currentUrl.toString();
    }
  }

  clearSelections() {
    this.clearData();
    this.showSelectedRoles();
    this.updateSelectedText();
  }

  clearData() {
    const subRolesToDisplay = document.querySelectorAll(`.roles-sub-text`);
    subRolesToDisplay.forEach((subRole) => {
      subRole.style.display = 'flex';
    });

    if (this.anotherCategoryDiv) {
      this.anotherCategoryDiv.innerHTML = '';
     }

    this.roleTextElement.classList.remove("opacity");
    this.roleIcon.classList.remove("opacity");
    this.selectedRoles = [];
    this.lastRemoved = false;

    document.querySelectorAll('.roles-sub-text').forEach(item => {
      item.classList.remove('selected');
    });
    document.querySelectorAll('.main-category-container').forEach((container) => {
        container.remove();
    });
  }

  updateSubmenuTitle(event) {
    document.getElementById('role-search-and-selection').classList.add('hidden');
    const row = event.currentTarget.closest(".roles-main-position") || event.currentTarget.closest(".icon-height-next");
    const roleName = row.getAttribute("data-role-name");
    this.changeHeader('Back', 'Search by name', roleName);
    const inputBox = event.currentTarget.closest(".roles-main");
    this.resetSearchInputs(inputBox);
    this.updatePickARoleText(false, this.selectedRoles.length > 0 ? "Pick another role" : "Pick a role:");
  }

   toggleDropdown(event) {
    event.preventDefault(); // stop <button> from submitting or following default toggle
    event.stopPropagation(); // stop Foundation's click handler from also running

    if (this.roleTarget.classList.contains('is-open')) {
      this.closeDropdown();
    } else {
      this.openDropdown();
        const simulatedEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        this.roleTarget.dispatchEvent(simulatedEvent);
    }
  }

  showSelectedRoles() {
    const urlParams = new URLSearchParams(window.location.search);
    const roleTypes = Array.from(new Set(urlParams.getAll("roles[]")));

    if (roleTypes.length === 0) return;

    let categoryUpdated = JSON.parse(localStorage.getItem('updateCatergoryHash')) || {};

    roleTypes.forEach((subCategory) => {
      // Split ID and name if in "ID,Name" format
      const [roleId, roleName] = subCategory.includes(',') ? subCategory.split(',') : [null, subCategory];
      const searchValue = roleName || subCategory;
      const mainCategory = categoryUpdated[subCategory];

      if (this.industryHasCategories) {
        // Mark the role as selected in the drilldown first
        const roleElement = document.querySelector(`[data-role-type='${searchValue}']`);
        if (roleElement) {
          roleElement.classList.add('selected');
        }

        // Add to selected roles array with full "ID,Name" format
        if (!this.selectedRoles.includes(subCategory)) {
          this.selectedRoles.push(subCategory);
        }

        // Add to display if we have the category and it's not already displayed
        if (mainCategory) {
          const existingItem = document.querySelector(`.selected-roles-container [data-role-type="${searchValue}"]`);
          if (!existingItem) {
            this.addRoleToDisplay(searchValue, roleId, mainCategory);
          }
        }
      } else {
        this.addRoleToDisplay(searchValue, roleId);

        // Add to selected roles array only if not already present
        if (!this.selectedRoles.includes(subCategory)) {
          this.selectedRoles.push(subCategory);
        }

        const roleElement = document.querySelector(`[data-role-type='${searchValue}']`);
        if (roleElement) {
          roleElement.classList.add('selected');
        }
      }
    });

    this.updateSelectedRoles();
    this.updateLimitMessage();
    this.updateApplyButtonVisibility();
  }

  resetOptions() {
    this.clearData();
    this.updateSelectedText(true);
    const currentUrl = new URL(window.location.href);

    currentUrl.searchParams.delete("roles[]");
    currentUrl.searchParams.delete('page');
    window.location.href = currentUrl.toString();
    this.roleBox.classList.remove("selected");
    $(this.roleTarget).foundation('close');
  }

  clearOptions() {
    this.clearSelections();
    this.roleBox.classList.remove("selected");
    $(this.roleTarget).foundation('close');
  }

  addCategoryData(subCategory, mainCategory) {
    if (!subCategory || !mainCategory) return;

    this.category[subCategory] = mainCategory;
    this.updateCategory();
  }

  addMainCategoryData(subCategory) {
    if (!subCategory) return;

    this.category[subCategory] = subCategory;
    this.updateCategory();
  }

  removeCategoryData(subCategory) {
    if (!(subCategory in this.category)) return;

    delete this.category[subCategory];
    this.updateCategory();
  }

  updateCategory() {
    localStorage.setItem("updateCatergoryHash", JSON.stringify(this.category));
  }

  resetSearchInputs(row) {
    const searchInput = row.querySelector(".role-search-input");
    searchInput && (searchInput.value = '');

    const searchIcon = row.querySelector(".search-icon");
    searchIcon && (searchIcon.style.display = '');

    const roleItems = row.querySelectorAll(".roles-sub-text");
    roleItems.forEach((item) => {
      item.style.display = item.classList.contains('selected') ? 'none' : '';
    });
  }

  resetMainSearchInputs() {
    const searchInput = document.querySelector(".main-roles-input");
    searchInput && (searchInput.value = '');

    const searchIcon = document.querySelector(".roles-main-icon");
    searchIcon && (searchIcon.style.display = '');

    const roleItems = document.querySelectorAll(".roles-main");
    if (this.isInSubmenu()) return;
    roleItems.forEach((item) => {
      item.style.display = item.classList.contains('selected') ? 'none' : '';
    });
  }

  addMainRoleToDisplay(roleType, roleId) {
    // Check if role is already displayed to prevent duplicates
    const existingItem = this.element.querySelector(`[data-role-type="${roleType}"]`);
    if (existingItem) {
      return;
    }

    const subRole = this.element.querySelector(`.roles-sub-text[data-role-type="${roleType}"]`);
    if (subRole) {
      subRole.style.display = 'none';
    }

    const container = document.createElement("div");
    container.classList.add("main-category-container");
    container.innerHTML = `
      <div class="subcategory-roles-list"></div>
    `;
    this.element.querySelector(".selected-main-roles-container").appendChild(container);

    const subcategoryList = this.element.querySelector(".subcategory-roles-list");
    const subcategoryItem = document.createElement("li");
    subcategoryItem.dataset.roleType = roleType;
    subcategoryItem.innerHTML = `
    <label style="display: flex; line-height: 1.2rem; align-items: center; padding-left: 0.625rem;">
      <input id="checkbox-${roleType}"
        class="role-checkbox"
        type="checkbox"
        checked
        data-role-type="${roleType}"
        data-role-id="${roleId}"
        data-action="change->roles-marketplace#toggleMainCheckbox" />
      <span class="role-checkbox-text" onclick="event.preventDefault();">${roleType}</span>
    </label>
    `;

    subcategoryList.appendChild(subcategoryItem);
    this.updateLimitMessage()
  }

  removeMainRoleFromDisplay(roleType) {
    this.removeCategoryData(roleType);
    if (this.selectedRoles.length === 0 && this.anotherCategoryDiv) {
      this.anotherCategoryDiv.innerHTML = '';
     }
    const subRole = this.element.querySelector(`.roles-sub-text[data-role-type="${roleType}"]`);
    subRole.style.display = 'flex';

    if (this.selectedRoles.length == 0) {
      const element = document.getElementById("noMainResults");
      if (element) {
        element.classList.add("display-none");
      }
    }

    const subcategoryItem = this.element.querySelector(`[data-role-type="${roleType}"]`);
    if (subcategoryItem) subcategoryItem.remove();
  }

  toggleMainCheckbox(event) {
    const roleCategory = event.currentTarget.dataset.roleType;
    const roleId = event.currentTarget.dataset.roleId;
    const subRole = this.element.querySelector(`.roles-sub-text[data-role-type="${roleCategory}"]`);
    const roleValue = roleId ? `${roleId},${roleCategory}` : roleCategory;

    if (event.currentTarget.checked) {
      this.selectedRoles.push(roleValue);
    } else {
      this.selectedRoles = this.selectedRoles.filter((role) => role !== roleValue);
      subRole.classList.remove('selected');
      this.removeMainRoleFromDisplay(roleCategory);
    }

    this.updateLimitMessage()
    this.updateApplyButtonVisibility();
  }

  filterRolesForHealthCare(event) {
    const query = event.target.value.trim().toLowerCase();
    let categoriesWithRoles = document.getElementById('search-categories-with-roles')
    let categories = document.getElementById('role-search-categories-healthcare')
    let hasResults = false

    if (query === '') {
      this.showNoResultsMessage(true);
      categoriesWithRoles.style.display = 'flex';
      categories.classList.add('hidden')

      // Reinitialize Foundation drilldown
      const $el = $('.drilldown');

      const existing = $el.data('zfPlugin');
      if (existing && typeof existing.destroy === 'function') {
        existing.destroy();
      }

      if ($el.parent().hasClass('is-drilldown')) {
        $el.unwrap();
      }

      $el.removeClass('drilldown')
         .removeAttr('aria-multiselectable data-mutate data-events role')
         .attr('data-drilldown', '');

      $el.find('ul')
         .removeClass('is-drilldown-submenu is-active invisible')
         .removeAttr('data-submenu data-submenu-id data-parent-submenu data-index');

      $el.find('li')
         .removeClass('is-submenu-item is-active')
         .removeAttr('data-is-active');

      const drilldown = new Foundation.Drilldown($el);
      $el.data('zfPlugin', drilldown);

      // Focus the search input after resetting
      const input = this.element.querySelector('.role-search-input');
      input && input.focus();
    } else {
      categories.classList.remove('hidden')
      categoriesWithRoles.style.display = 'none';

      // Clear previous results but preserve the add-another div
      const addAnother = categories.querySelector('.add-another');
      categories.innerHTML = '';
      categories.appendChild(addAnother);

      // Search through all categories and their roles
      document.querySelectorAll("#search-categories-with-roles .roles-main").forEach((categoryElement) => {
        const categoryName = categoryElement.querySelector('.roles-main-position').textContent.trim();
        const matchingRoles = [];

        // Find roles within this category that match the search
        categoryElement.querySelectorAll('.roles-sub-text').forEach((roleElement) => {
          const roleText = roleElement.textContent.trim().toLowerCase();
          if (roleText.includes(query)) {
            matchingRoles.push({
              name: roleElement.textContent.trim(),
              dataRoleType: roleElement.getAttribute('data-role-type'),
              dataRoleId: roleElement.getAttribute('data-role-id')
            });
          }
        });

        // If category has matching roles, display them
        if (matchingRoles.length > 0) {
          hasResults = true;

          // Add category header
          const categoryItem = document.createElement('li');
          categoryItem.classList.add('marketplace-profile-role-filter-search-category-heading');
          categoryItem.innerHTML = `<div>${categoryName}</div>`;
          categories.appendChild(categoryItem);

          // Add each matching role
          matchingRoles.forEach(role => {
            const roleItem = document.createElement('li');
            roleItem.setAttribute('data-id', role.dataRoleType);
            roleItem.innerHTML = `
              <a data-action="click->roles-marketplace#toggleRole"
                data-target="roles-marketplace.roleItem"
                data-role-type="${role.name}"
                data-role-id="${role.dataRoleId || ''}"
                data-category-name="${categoryName}"
                class="roles-menu roles-main-text"
              >
                <div class="roles-main-position no-padding roles-sub-text roles-sub-position roles-main-value">
                  ${role.name}
                </div>
              </a>
            `;
            categories.appendChild(roleItem);
          });
        }
      });

      this.showNoResultsMessage(hasResults);
    }
  }

  filterMainRoles() {
    const searchInput = document.querySelector(".main-roles-input");
    const searchTerm = searchInput.value.toLowerCase();
    const searchIcon = this.element.querySelector(".roles-main-icon");
    const roleSubs = document.querySelectorAll(".roles-sub-text");
    let hasResults = false;

    searchIcon.style.display = searchTerm.length > 0 ? "none" : "";

    roleSubs.forEach((roleSub) => {
      const roleText = roleSub.textContent.toLowerCase();
      const closestRoleMain = roleSub.closest(".roles-main");

      if (roleSub.classList.contains("selected")) {
        closestRoleMain.style.display = "none";
      } else {
        if (roleText.includes(searchTerm.trim())) {
          closestRoleMain.style.display = "";
          hasResults = true;
        } else {
          closestRoleMain.style.display = "none";
        }
      }
    });

    this.showNoResultsMessage(hasResults);
  }

  showNoResultsMessage(hasResults) {
    document.querySelector(".is-drilldown").classList.toggle('hidden', !hasResults);
    document.getElementById('no-match-message').classList.toggle('hidden', hasResults);
  }

  handleEscapePress(event) {
    if (event.key === "Escape") {
      this.closeDropdown();
    }
  }
}
